<script setup lang="ts">
import type { CmsElementHistorySlider } from "~/composables/useCustom";
import HistorySliderItem from "./items/HistorySliderItem.vue";

const props = defineProps<{
  content: CmsElementHistorySlider;
}>();

const { Slides } = props.content.data;
const data = props.content.data;



const historySlider = ref(null);
const historySwiperSlider = useSwiper(historySlider, {
  effect: "slide",
  loop: true,
  autoplay: false,
  slidesPerView: 1,
});

const showSlider = ref(false);

const slides = computed(() => {
  return Slides || []
})

const isSliderReady = computed(() => historySwiperSlider.instance.value?.initialized || false);

watch(isSliderReady, () => {
  if (isSliderReady.value) {
    showSlider.value = true
  }
})

</script>

<template>
  <div class="cust-slider-history px-4">
    <div class="container mx-auto relative pt-12 pb-16 md:pb-24 sm:py-24">
      <div class="wrap flex items-center justify-between gap-4 mb-8 md:mb-14">
        <div class="title max-w-[60%]">
          <h3 class="h3-font">{{ data.headlineText }}</h3>
        </div>

        <div
          class="space-x-0 md:space-x-4 w-auto flex items-center justify-center relative flex-col md:flex-row"
        >

          <div v-if="slides.length > 1" class="nav-wrap space-x-2 w-[120px] md:w-auto md:space-x-4 flex items-center justify-between md:justify-center">
            <button
              @click="historySwiperSlider.prev()"
              class="inspire-left-control fas fa-chevron-left cust-slide-left-control bg-white md:bg-medium-grey text-dark-bg md:text-white text-sm md:text-xs w-14 h-14 md:w-11 md:h-11 flex items-center justify-center rounded-full focus:outline-none hover:text-white hover:bg-dark-bg transition duration-300 slick-arrow relative left-0 shadow-md md:shadow-none"
            ></button>
            <button
              @click="historySwiperSlider.next()"
              class="inspire-right-control fas fa-chevron-right cust-slide-right-control bg-white md:bg-medium-grey text-dark-bg md:text-white text-sm md:text-xs w-14 h-14 md:w-11 md:h-11 flex items-center justify-center rounded-full focus:outline-none hover:text-white hover:bg-dark-bg transition duration-300 slick-arrow relative right-0 shadow-md md:shadow-none"
            ></button>
          </div>
        </div>
      </div>

      <!-- Skeleton loader -->
      <div v-if="!showSlider" class="flex flex-col md:flex-row md:gap-6 gap-1">
        <div v-for="i in 2" :key="i" class="animate-pulse w-full">
          <div class="bg-gray-200 h-80 rounded-lg mb-4"></div>
        </div>
      </div>

      <swiper-container v-show="showSlider" class="slider our-history-slider" ref="historySlider">
        <swiper-slide class="inner-wrap" v-for="slide in slides">
          <HistorySliderItem :slide="slide" />
        </swiper-slide>
      </swiper-container>
    </div>
  </div>
</template>
